RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Invoice = Marionette.ItemView.extend({
        template: '#invoiceTemplate',

        serializeData: function () {
            const me = this;
            const presentInvoice = App.models.presentInvoice;
            const presentInvoiceSettings = App.models.presentInvoiceSettings;

            return _.tap(presentInvoice(this.model.toJSON()), function (presentedInvoice) {
                presentedInvoice.invoiceSettings = presentInvoiceSettings(me.getOption('account').get('settings').invoiceSettings);
                presentedInvoice.owner = me.getOption('owner').toJSON();
            });
        }
    });
});
